import { Dispatch, SetStateAction } from 'react';
import { IconArrowTop, IconArrowDown } from 'components/Icons';
import { baseTheme } from 'styles/utils';
import { inputNavSection } from './InputActionBar.styles';

export const InputNavigation = ({ total, current, setCurrent }: Props): JSX.Element => (
  <div className={inputNavSection} data-testid="inputcount-div">
    <button type="button" data-testid="prev-button" onClick={() => setCurrent(current === 1 ? 1 : current - 1)}>
      <IconArrowTop size={12} color={baseTheme.light.colors.gray500} />
    </button>
    <div className="current">{current}</div>
    <button type="button" data-testid="next-button" onClick={() => setCurrent(current === total ? current : current + 1)}>
      <IconArrowDown size={12} color={baseTheme.light.colors.gray500} />
    </button>
  </div>
);

interface Props {
  total: number;
  current: number;
  setCurrent: Dispatch<SetStateAction<number>> | ((n: number) => void);
}
